import 'swiper/css'
import 'swiper/css/pagination'

import React from 'react'
import { Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react'

import { useAppDispatch, useAppSelector } from '@/core/store'
import { closeModal } from '@/core/store/ui.store'

import { IconBack, IconClose } from '../Ui/Icons'

export const TutorialSlides = () => {
  const { modal } = useAppSelector((store) => store.uiState)
  const dispatch = useAppDispatch()

  const slides = [
    { id: 1, image: '/img/tutorial/step1.webp', title: 'Step1' },
    { id: 2, image: '/img/tutorial/step2.webp', title: 'Step2' },
    { id: 3, image: '/img/tutorial/step3.webp', title: 'Step3' },
    { id: 4, image: '/img/tutorial/step4.webp', title: 'Step4' },
    { id: 5, image: '/img/tutorial/step5.webp', title: 'Step5' },
    { id: 6, image: '/img/tutorial/step6.webp', title: 'Step5' },
    { id: 7, image: '/img/tutorial/step7.webp', title: 'Step5' },
    { id: 8, image: '/img/tutorial/step8.webp', title: 'Step5' },
    { id: 9, image: '/img/tutorial/step9.webp', title: 'Step5' },
    { id: 10, image: '/img/tutorial/step10.webp', title: 'Step5' },
    { id: 11, image: '/img/tutorial/step11.webp', title: 'Step5' },
    { id: 12, image: '/img/tutorial/step12.webp', title: 'Step5' },
    { id: 13, image: '/img/tutorial/step13.webp', title: 'Step5' },
    { id: 14, image: '/img/tutorial/step14.webp', title: 'Step5' },
    { id: 15, image: '/img/tutorial/step15.webp', title: 'Step5' },
  ]
  return (
    <div className={'tutorial-slides' + (modal === 'tutorial-slides' ? ' active' : '')}>
      <div className="tutorial-container">
        <div className="tutorial-header">
          <div>
            <h1 className="tutorial-title">Tutorial</h1>
          </div>
          <div>
            <a onClick={() => dispatch(closeModal())}>
              <IconClose white={true}></IconClose>
            </a>
          </div>
        </div>

        <Swiper
          modules={[Pagination, Navigation]}
          spaceBetween={50}
          slidesPerView={1}
          pagination={{
            clickable: true,
            renderBullet: (index, className) => {
              return `<span class="${className}"></span>`
            },
          }}
          navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }}
          className="tutorial-swiper"
        >
          {slides.map((slide) => (
            <SwiperSlide key={slide.id}>
              <div className="slide-content">
                <img src={slide.image} alt={slide.title} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="swiper-button-prev">
          <IconBack></IconBack>
        </div>
        <div className="swiper-button-next"></div>
      </div>
    </div>
  )
}
